// 产品页详情数据
export const productDetailObj = {
    101: {
        img: require('@/assets/products1/bigimg1.png'),
        title: "1L1H Multi Band 4ports",
        chipset: 'PM6X8IS-611041',
        frequency: '1x698-960 /1x1710-2690',
        hor: '65/65',
        gain: '16/18',
        electrical: '2-12/2-12',
        dimension: '1999x265x144',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x4',

    },
    102: {
        img: require('@/assets/products1/bigimg2.png'),
        title: "1L1H Multi Band 4ports",
        chipset: 'PM7X8IS-611041',
        frequency: '1x690-960 /1x1695-2690',
        hor: '65/65',
        gain: '17/18',
        electrical: '2-12/2-12',
        dimension: '2500x330x179',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x4',
    },
    103: {
        img: require('@/assets/products1/bigimg3.png'),
        title: "1L2H Multi Band 6ports",
        chipset: 'PM5X8IS-612061',
        frequency: '1x690-960/2x1710-2690',
        hor: '65/65',
        gain: '15/18',
        electrical: '2-16/2-12',
        dimension: '1600x330x179',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x6',
    },
    104: {
        img: require('@/assets/products1/bigimg4.png'),
        title: "1L2H Multi Band 6ports",
        chipset: 'PM6X8IS-612061',
        frequency: '1x698-960/2x1710-2690',
        hor: '65/65',
        gain: '16/18',
        electrical: '2-12/2-12',
        dimension: '1999x330x179',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x6',
    },
    105: {
        img: require('@/assets/products1/bigimg5.png'),
        title: "1L2H Multi Band 6ports",
        chipset: 'PM7X8IS-612061',
        frequency: '1x690-960/2x1710-2690',
        hor: '65/65',
        gain: '17/18',
        electrical: '2-12/2-12',
        dimension: '2500x330x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x6',
    },
    106: {
        img: require('@/assets/products1/bigimg6.png'),
        title: "1L3H Multi Band 8ports",
        chipset: 'PM6W8IS-613081',
        frequency: '1x690-960/1x1710-2690 /1x1710-2170 /1x2300-2690',
        hor: '65/65/65/65',
        gain: '16/18/17.5/18',
        electrical: '2-12/2-12/2-12/2-12',
        dimension: '1996x350x200',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x8',
    },
    107: {
        img: require('@/assets/products1/bigimg7.png'),
        title: "1L3H Multi Band 8ports",
        chipset: 'PM6X8IS-613081',
        frequency: '1x690-960/3x1695-2690',
        hor: '65/65',
        gain: '16/18',
        electrical: '2-12/2-12',
        dimension: '1999x379x144',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x8',
    },
    108: {
        img: require('@/assets/products1/bigimg8.png'),
        title: "1L3H Multi Band 8ports",
        chipset: 'PM7X8IS-613081',
        frequency: '1x690-960/3x1695-2690',
        hor: '65/65',
        gain: '17/18',
        electrical: '2-12/2-12',
        dimension: '2500x330x179',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x8',
    },
    109: {
        img: require('@/assets/products1/bigimg9.png'),
        title: "1L4H Multi Band 10ports",
        chipset: 'PM6W8IS-614101',
        frequency: '1x698-960/2x1710-2170/2x2490-2690',
        hor: '65/65/65',
        gain: '16/17/17.5',
        electrical: '2-12/2-12/2-12',
        dimension: '2000x330x179',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x10',
    },
    1010: {
        img: require('@/assets/products1/bigimg10.png'),
        title: "1L4H Multi Band 10ports",
        chipset: 'PM6X6IS-614101',
        frequency: '1x698-960/4x 1710-2690',
        hor: '65/65',
        gain: '16/16',
        electrical: '2-12/2-12',
        dimension: '1999x330x179',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x10',
    },
    1011: {
        img: require('@/assets/products1/bigimg11.png'),
        title: "1L4H Multi Band 10ports",
        chipset: 'PM7X8IS-614101',
        frequency: '1x698-960/4x1710-2690',
        hor: '65/65',
        gain: '17/18',
        electrical: '0-10/0-10',
        dimension: '2750x330x179',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x10',
    },
    1012: {
        img: require('@/assets/products1/bigimg12.png'),
        title: "1L5H Multi Band 12 ports",
        chipset: 'Pa7X8IS-615121',
        frequency: '1x617-894 /5x1710-2690',
        hor: '65/65',
        gain: '17/18',
        electrical: '2-12/2-12',
        dimension: '2495x399x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x12',
    },
    1013: {
        img: require('@/assets/products1/bigimg13.png'),
        title: "2L2H Multi Band 8 ports",
        chipset: 'PM5X8IS-622081',
        frequency: '2x698-960 /2x1710-2690',
        hor: '65/65',
        gain: '15/18',
        electrical: '2-16/2-12',
        dimension: '1500x449x159',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x8',
    },
    1014: {
        img: require('@/assets/products1/bigimg14.png'),
        title: "2L2H Multi Band 8 ports",
        chipset: 'PL6X8IS-622081',
        frequency: '2x790-960 /2x1710-2690',
        hor: '65/65',
        gain: '16/18',
        electrical: '0-10/2-12',
        dimension: '2000x429x159',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x8',
    },
    1015: {
        img: require('@/assets/products1/bigimg15.png'),
        title: "2L2H Multi Band 8 ports",
        chipset: 'PM6X8IS-622081',
        frequency: '2x690-960 /2x1710-2690',
        hor: '65/65',
        gain: '16/18',
        electrical: '2-12/2-12',
        dimension: '2050x449x188',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x8',
    },
    1016: {
        img: require('@/assets/products1/bigimg16.png'),
        title: "2L2H Multi Band 8 ports",
        chipset: 'PM7X8IS-622081',
        frequency: '2x698-960 /2x1710-2690',
        hor: '65/65',
        gain: '17/18',
        electrical: '2-12/2-12',
        dimension: '2500x449x188',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x8',
    },
    1017: {
        img: require('@/assets/products1/bigimg17.png'),
        title: "2L2H Multi Band 8 ports",
        chipset: 'PM7X9IS-322081',
        frequency: '2x690-960 /2x1695-2690',
        hor: '30/30',
        gain: '17/19',
        electrical: '2-12/2-12',
        dimension: '2500x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x8',
    },
    1018: {
        img: require('@/assets/products1/bigimg18.png'),
        title: "2L2H Multi Band 8 ports",
        chipset: 'PMBXBIS-322081',
        frequency: '2x690-960 /2x1710-2690',
        hor: '30/30',
        gain: '21/21',
        electrical: '2-12/2-12',
        dimension: '2600x649x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x8',
    },
    1019: {
        img: require('@/assets/products1/bigimg19.png'),
        title: "2L3H Multi Band 10 ports",
        chipset: 'PM6X8IS-623101',
        frequency: '2x698-960 /3x1710-2690',
        hor: '65/65',
        gain: '16/18',
        electrical: '2-12/2-12',
        dimension: '1980X449x188',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x10',
    },
    1020: {
        img: require('@/assets/products1/bigimg20.png'),
        title: "2L4H Multi Band 12 ports",
        chipset: 'PM5W8IS 624121',
        frequency: '2x698-960/2x1710-2170/2x2490-2690',
        hor: '65/65/65',
        gain: '15/17.5/18',
        electrical: '2-12/2-12',
        dimension: '1600x449x180',
        radome: 'UPVC',
        connector: '4.3-10(F)x12',
    },
    1021: {
        img: require('@/assets/products1/bigimg21.png'),
        title: "2L4H Multi Band 12 ports",
        chipset: 'PM5X7IS-624121',
        frequency: '2x690-960 /4x1695-2690',
        hor: '65/65',
        gain: '15/17',
        electrical: '2-14/2-12',
        dimension: '1500x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x12',
    },
    1022: {
        img: require('@/assets/products1/bigimg22.png'),
        title: "2L4H Multi Band 12 ports",
        chipset: 'PM6X7IS-624121',
        frequency: '2x 690-960 /4x1695-2690 ',
        hor: '65/65',
        gain: '16/17',
        electrical: '2-12/2-12 ',
        dimension: '2000x449x188',
        radome: 'UPVC',
        connector: '4.3-10(F)x12',
    },
    1023: {
        img: require('@/assets/products1/bigimg23.png'),
        title: "2L4H Multi Band 12 ports",
        chipset: 'PL6X6IS-624121',
        frequency: '2x790-960 /4x1710-2690',
        hor: '65/65',
        gain: '16/16',
        electrical: '0-10/2-12',
        dimension: '2000x429x175',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x12',
    },
    1024: {
        img: require('@/assets/products1/bigimg24.png'),
        title: "2L4H Multi Band 12 ports",
        chipset: 'PM6X8IS-624121',
        frequency: '2x 690-960/4x 1695-2690',
        hor: '65/65',
        gain: '16/18',
        electrical: '2-12/2-12',
        dimension: '2000x469x206',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x12',
    },
    1025: {
        img: require('@/assets/products1/bigimg25.png'),
        title: "2L4H Multi Band 12 ports",
        chipset: 'PM7X8IS-624121',
        frequency: '2x 698-960/4x 1710-2690',
        hor: '65/65',
        gain: '17/18',
        electrical: '2-12/2-12',
        dimension: '2750x449x188',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x12',
    },
    1026: {
        img: require('@/assets/products1/bigimg26.png'),
        title: "2L5H Multi Band 14 ports",
        chipset: 'PM7X8IS-625141',
        frequency: '2x698-960/5x1710-2690',
        hor: '65/65',
        gain: '17/18',
        electrical: '2-12/2-12',
        dimension: '2650x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x14',
    },
    1027: {
        img: require('@/assets/products1/bigimg27.png'),
        title: "2L6H Multi Band 16 ports",
        chipset: 'PM6X7IS-626161',
        frequency: '2x690-960 /6x1695-2690',
        hor: '65/65',
        gain: '16/17',
        electrical: '2-12/2-12',
        dimension: '2050x449x188',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },

    1028: {
        img: require('@/assets/products1/bigimg28.png'),
        title: "2L8H Multi Band 20 ports",
        chipset: 'PM6X7IS-628201',
        frequency: '2x698-960 /8x1710-2690',
        hor: '65/65',
        gain: '16/17',
        electrical: '2-12/2-12',
        dimension: '2580x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x20',
    },
    1029: {
        img: require('@/assets/products1/bigimg29.png'),
        title: "3L4H Multi Band 14 ports",
        chipset: 'PM6X8IS-634141',
        frequency: '1x 698-960/1x 698-860/1x 880-960/4x 1710-2690',
        hor: '65/65/65/65',
        gain: '16/15.5/16/18',
        electrical: '2-12/2-12/2-12/2-12',
        dimension: '2650x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x14',
        
    },
    1030: {
        img: require('@/assets/products1/bigimg30.png'),
        title: "3L5H Multi Band 16 ports",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    201: {
        img: require('@/assets/products2/detailimg1.png'),
        title: "Huawei HECM Board QCU1HECMA",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    202: {
        img: require('@/assets/products2/detailimg2.png'),
        title: "Huawei WRFUe 2100MHz 02310JWY",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    203: {
        img: require('@/assets/products2/detailimg3.png'),
        title: "FDD 4TR（700M800M900M）",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    204: {
        img: require('@/assets/products2/detailimg4.png'),
        title: "BBU",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    301: {
        img: require('@/assets/products3/bigimg1.png'),
        footerimg: require('@/assets/products3/detailimg1.png'),
        title: "ZLT X80 Pro",
        chipset: 'CHIPSET:QUALCOMM X72 （ 5G）',
        nextwork: "NSA&SA",
        bands: [
            '5G:N1/2/3/5/7/8/12/13/14/20/25/26/28/29/30/38/40/41/4866/70/71/75/76/77/78',
            '4G:B1/2/3/4/5/7/8/12(17)/13/14/20/25/26/28/29/30/32/38/40/41/42/43/48/66/71',
            'WCDMA:B1/5/8/46',
        ],
        battery: '1000mAh',
        throughput5: ['4Gbps(DL)', '2Gbps(UL)'],
        mimo5: ['DLMIMO 4*4', 'ULMIMO 2*2'],
        wifi7: ['BE19000', 'MIMO 4*4'],
        interface: ['RJ45 1*5G+3*2.5G', 'RJ11 optional']
    },
    302: {
        img: require('@/assets/products3/bigimg2.png'),
        footerimg: require('@/assets/products3/detailimg2.png'),
        title: "ZLT X20",
        chipset: 'CHIPSET:QUALCOMM X72 （ 5G）',
        nextwork: "NSA & SA",
        bands: [
            '5G:N1/2/3/5/7/8/12/13/14/20/25/26/28/29/30/38/40/41/48/66/70/71/75/76/77/78',
            '4G: B1/2/3/4/5/7/8/12(17)/13/14/20/25/26/28/29/30/32/3840/41/42/43/48/66/71',
            'WCDMA:B1/5/8/46',
        ],
        battery: '10000mAh',
        throughput5: ['4Gbps (DL)', '2Gbps (UL)'],
        mimo5: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi7: ['BE19000', 'MIMO 4*4'],
        interface: ['RJ45 1*5G+3*2.5G', 'RJ11 optional']
    },
    303: {
        img: require('@/assets/products3/bigimg3.png'),
        footerimg: require('@/assets/products3/detailimg3.png'),
        title: "ZLT X300/Pro/Max",
        chipset: 'CHIPSET:MTK T830 （ 5G）',
        nextwork: "NSA & SA",
        bands: ['5G:N1/3/5/7/8/20/28/3840/41/71/75/77/78/79', '4G FDD: B1/3/5/7/8/20/28/32/71', '4G TDD:B38/40/41/42/43'],
        power: 'DC /Type-C(Quick Charge)',
        throughput5: ['7Gbps (DL)', '2.5Gbps(UL)'],
        mimo5: ['DL MIMO 4*4', 'UL MIMO 2*2', 'MIMO 4*4(WiFi)'],
        interface: ['RJ11 optional']
    },
    304: {
        img: require('@/assets/products3/bigimg4.png'),
        footerimg: require('@/assets/products3/detailimg4.png'),
        title: "ZLT X300/Pro/Max",
        chipset: 'CHIPSET:MTK T750 （ 5G）',
        nextwork: "NSA & SA",
        bands: ['5G:N1/3/5/7/8/20/28/3840/41/71/77/78', '4G FDD:B1/3/5/7/8/20/28/32', '4G TDD:B38/40/41/42/43'],
        throughput5: ['4Gbps (DL)', '1Gbps(UL)'],
        mimo5: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi6: ['AX1800 (X25 Pro)', 'AX3000(X25Max)', 'MIMO 2*2'],
        interface: ['RJ45 2*2.5G', 'RJ11 optional']
    },
    305: {
        img: require('@/assets/products3/bigimg3.png'),
        footerimg: require('@/assets/products3/detailimg3.png'),
        title: "X25 Ultra",
        chipset: 'CHIPSET:MTK T750 （ 5G）',
        nextwork: "NSA & SA",
        bands: ['5G:N1/3/5/7/8/20/28/3840/41/71/77/78', '4G FDD: B1/3/5/7/8/20/28/32', '4G TDD: B38/40/41/42/43',],
        throughput5: ['4Gbps (DL)', '1Gbps (UL)'],
        mimo5: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi6: ['AX 1800', 'MIMO 2*2'],
        interface: ['RJ45 2*2.5G+2*1G', 'RJ11 optional']
    },
    306: {
        img: require('@/assets/products3/bigimg3.png'),
        footerimg: require('@/assets/products3/detailimg3.png'),
        title: "ZLT X28",
        chipset: 'CHIPSET:MTK T750 （ 5G）',
        nextwork: "NSA & SA",
        bands: ['5G:N1/3/5/7/8/20/28/3840/41/71/77/78', '4G FDD:B1/3/5/7/8/20/28/32', '4G TDD: B38/40/41/42/43',],
        throughput5: ['4Gbps (DL)', '1Gbps (UL)'],
        mimo5: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi6: ['AX 1800', 'MIMO 2*2'],
        interface: ['RJ451*2.5G+3*GE', 'RJ11 optional']
    },
    307: {
        img: require('@/assets/products3/bigimg3.png'),
        footerimg: require('@/assets/products3/detailimg3.png'),
        title: "ZLT X500",
        chipset: 'CHIPSET:UNISOC V8520 （ 5G）',
        nextwork: "NSA & SA",
        bands: ['5G:N1/3/5/7/8/20/28/38/40/41/77/78', '4G-FDD: B1/3/5/7/8/20/28/32', '4G-TDD: B38/40/41/42/43'],
        throughput5: ['4Gbps(DL)', '1Gbps(UL)'],
        mimo5: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi6: ['AX 3000', 'MIMO 2*2'],
        interface: ['RJ451*2.5G+3*1G', 'RJ11 optional']
    },
    308: {
        img: require('@/assets/products3/bigimg3.png'),
        footerimg: require('@/assets/products3/detailimg3.png'),
        title: "ZLT X25/X25Plus",
        chipset: 'CHIPSET:UNISOC V510 （ 5G）',
        nextwork: "NSA & SA",
        bands: ['5G:N1/3/7/8/28/38/4041/77/78/79', 'LTE: B1/2/3/4/5/7/8/20/28A/28/66/34/38/39/40/41',],
        throughput5: ['2Gbps (DL)', '1Gbps(UL)'],
        mimo5: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi6: ['AX 1500(X25)', 'AX 3000 (X25 Plus)', 'MIMO 2*2'],
        interface: ['RJ45 2*1Gbps', 'RJ11 optional']
    },
    309: {
        img: require('@/assets/products3/bigimg9.png'),
        footerimg: require('@/assets/products3/detailimg9.png'),
        title: "ZLT X100",
        chipset: 'CHIPSET:UNISOC V510 （ 5G）',
        nextwork: "NSA & SA",
        bands: ['5G:N1/3//8/28/41/77/78', 'LTE: B1/3/5/8/34/38/39/40/41',],
        nfc: 'One-Touch',
        throughput5: ['2Gbps(DL)', '1Gbps (UL)'],
        mimo5: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi6: ['AX 1500', 'MIMO 2*2'],
        interface: ['RJ45 1*GE']
    },
    3010: {
        img: require('@/assets/products3/bigimg10.png'),
        footerimg: require('@/assets/products3/detailimg10.png'),
        title: "ZLT X180",
        chipset: 'CHIPSET:EN7562CT+UNISOC V510 （ 5G）',
        nextwork: "NSA & SA",
        bands: ['5G:N1/N3/N8/N28/N41/N77/N78/N79', '4G-FDD: B1/B3/B5/B8', '4G-TDD: B34/B38/B39/B40/B41',],
        battery: '10000mAh',
        throughput5: ['2Gbps (DL)', '1Gbps(UL)'],
        mimo5: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi6: ['AX3000', 'MIMO 2*2'],
        interface: ['RJ451*2.5G+3*GE', 'RJ11*1(Optional)']
    },
    3011: {
        img: require('@/assets/products3/bigimg11.png'),
        footerimg: require('@/assets/products3/detailimg11.png'),
        title: "ZLT S91",
        chipset: 'CHIPSET:QUALCOM X12（4G CAT12/6）',
        nextwork: "LTE CAT6/CAT12",
        bands: [
            'LTE-FDD:B1/2/3/4/5/7/8/12/13/14/17/20/25/26/28/32/34/38/39/40/41/42/43/46/48/66/71',
            'LTE-TDD:B38/40/41/42/43/46/48',
            'WCDMA: B1/2/3/4/5/8'
        ],
        throughput4: ['CAT6:300 Mbps(L)/50 Mbps(UL)', 'CAT12:600 Mbps(DL)/150 Mbps(UL)'],
        mimo4: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi6: ['AX3000', 'MIMO 2*2'],
        interface: ['RJ45 2*1G', 'RJ11 optional']
    },
    3012: {
        img: require('@/assets/products3/bigimg12.png'),
        footerimg: require('@/assets/products3/detailimg12.png'),
        title: "ZLT S90",
        chipset: 'CHIPSET:QUALCOM X12（4G CAT12/6）',
        nextwork: "LTE CAT6/CAT12",
        bands: [
            'LTE-FDD:B1/2/3/4/5/7/8/12/13/14/17/20/25/26/28/32/34/38/39/40/41/42/43/46/48/66/71',
            'LTE-TDD:B38/40/41/42/43/46/48',
            'WCDMA:B1/2/3/4/5/8'
        ],
        battery: '7.4V/2500mAh',
        throughput4: ['CAT6:300 Mbps(DL)/50 Mbps (UL)', 'CAT12:600 Mbps(DL)/150 Mbps(UL)'],
        mimo4: ['DL MIMO 4*4', 'UL MIMO 2*2'],
        wifi5: ['AC1200', 'MIMO 2*2'],
        interface: ['RJ45 4*1G', 'RJ11 optional']
    },
    3013: {
        img: require('@/assets/products3/bigimg13.png'),
        footerimg: require('@/assets/products3/detailimg13.png'),
        title: "ZLT S50",
        chipset: 'CHIPSET:UNISOC SL8563（4G CAT6）',
        nextwork: "LTE CAT6",
        bands: [
            '4G FDD: B1/2/3/4/5/7/8/12/17/20/28/66',
            '4G TDD: B38/39/40/41',
            'WCDMA: B1/2/4/5/8',
            'GSM: B2/3/5/8',
        ],
        throughput4: ['300Mbps(DL)', '50Mbps(UL)'],
        mimo4: ['DL MIMO 2*2', 'UL MIMO 1*1'],
        wifi5: ['MIMO 2*2'],
        interface: ['RJ45 1*1GE', 'RJ11 optional']
    },
    3014: {
        img: require('@/assets/products3/bigimg14.png'),
        footerimg: require('@/assets/products3/detailimg14.png'),
        title: "ZLT T50",
        chipset: 'CHIPSET:UNISOC SL8563（4G CAT6）',
        nextwork: "LTE CAT6",
        bands: [
            '4G-FDD: B1/2/3/4/5/7/8/12/17/20/28/66',
            '4G-TDD: B38/39/40/41',
            'WCDMA: B1/2/4/5/8',
            'GSM: B2/3/5/8',
        ],

        throughput4: ['300Mbps(DL)', '50Mbps(UL)'],
        mimo4: ['DL MIMO 2*2', 'UL MIMO 1*1'],
        wifi5: ['MIMO 2*2'],
        interface: ['RJ45 1*1GE', 'RJ11 optional']
    },
    3015: {
        img: require('@/assets/products3/bigimg15.png'),
        footerimg: require('@/assets/products3/detailimg15.png'),
        title: "ZLT T35",
        chipset: 'CHIPSET:ZX297520V3E（4G CAT4）',
        nextwork: "LTE CAT4",
        bands: [
            'B1/2/3/4/5/7/8/20(28)/38/40/41',
        ],
        battery: '2500/3000mAh',
        throughput4: ['150Mbps(DL)', '50Mbps(UL)'],
        mimo4: ['DL MIMO 2*2', 'UL MIMO 1*1'],
        wifi4: ['MIMO 2*2'],
        interface: ['RJ45 4*100M', 'RJ11*1'],
        powerInput: 'DC / Type C( Quick Charge)',
    },
    3016: {
        img: require('@/assets/products3/bigimg16.png'),
        footerimg: require('@/assets/products3/detailimg16.png'),
        title: "ZLT S25",
        chipset: 'CHIPSET:ZX297520V3E（4G CAT4）',
        nextwork: "LTE CAT4",
        bands: [
            'B1/2/3/4/5/7/8/20(28)/38/40/41',
        ],
        battery: '7.4V/2000mAh',
        throughput4: ['150Mbps(DL)', '50Mbps(UL)'],
        mimo4: ['DL MIMO 2*2', 'UL MIMO 1*1'],
        wifi4: ['MIMO 2*2'],
        interface: ['RJ45 4*100M', 'RJ11*1']
    },
    3017: {
        img: require('@/assets/products3/bigimg17.png'),
        footerimg: require('@/assets/products3/detailimg17.png'),
        title: "ZLT T30",
        chipset: 'CHIPSET:ZX297520V3E（4G CAT4）',
        nextwork: "LTE CAT4",
        bands: [
            'B1/2/3/4/5/7/8/20(28)38/40/41',
        ],
        battery: '2500/3000mAh',
        throughput4: ['150Mbps(DL)', '50Mbps(UL)'],
        mimo4: ['DL MIMO 2*2', 'UL MIMO 1*1'],
        wifi4: ['MIMO 2*2'],
        interface: ['RJ454*100M', 'RJ11*1'],
        powerInput: 'DC / Type C ( Quick Charge)',

    },
    3018: {
        img: require('@/assets/products3/bigimg18.png'),
        footerimg: require('@/assets/products3/detailimg18.png'),
        title: "ZLT S20",
        chipset: 'CHIPSET:ZX297520V3E（4G CAT4）',
        nextwork: "LTE CAT4",
        bands: [
            'B1/2/3/4/5/7/8/20(28)/38/40/41',
        ],
        battery: '7.4V/2000mAh',
        throughput4: ['150Mbps(DL)', '50Mbps(UL)'],
        mimo4: ['DL MIMO 2*2', 'UL MIMO 1*1'],
        wifi4: ['MIMO 2*2'],
        interface: ['RJ451*100M', 'RJ11*1']
    },
    401: {
        img: require('@/assets/products4/detailimg1.png'),
        title: "CR52-NE40E-X3-BASE-AC",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    402: {
        img: require('@/assets/products4/detailimg2.png'),
        title: "HUAWEI GPON OLT MA5608T",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    403: {
        img: require('@/assets/products4/detailimg3.png'),
        title: "Paper Tablet",
        chipset:"Paper Tablet",
        price: '50USD',
        size:"10.3 inches",
        capacity: '128 GB',
        life: '2 weeks',
        resolution: '2480 x 1860 (300PPI)',
        color: 'Gray',
        dimensions: '22.6 cm in length x 19.8 cm in width x 0.6 cm in thickness',
    },
    501: {
        img: require('@/assets/products5/detailimg1.png'),
        title: "CITRANS 550F O155-2 S1.1 STM1 optical interface disk (2 way, S1.1, LC)",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    502: {
        img: require('@/assets/products5/detailimg2.png'),
        title: "FonsWeaver 780A",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    601: {
        img: require('@/assets/products5/detailimg1.png'),
        title: "CITRANS 550F O155-2 S1.1 STM1 optical interface disk (2 way, S1.1, LC)",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    602: {
        img: require('@/assets/products5/detailimg2.png'),
        title: "FonsWeaver 780A",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    701: {
        img: require('@/assets/products7/detailimg1.png'),
        title: "02311XBH H22H-05-S8AEF 2288H V5 8*2.5inch HDD Chassis",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    702: {
        img: require('@/assets/products7/detailimg2.png'),
        title: "02312AYU H58H-05-S8AFM 5885H V5 8*2.5 inch HDD Chassis",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    801: {
        img: require('@/assets/products8/detailimg1.png'),
        title: "Huawei OceanStor 18500 V5",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    802: {
        img: require('@/assets/products8/detailimg2.png'),
        title: "Huawei OceanStor Dorado 3000 V6 DV6-LPU2*100ETH-ML 03058974",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    901: {
        img: require('@/assets/products8/detailimg1.png'),
        title: "Delta ESR-48/50D E DPR48/50-C-DCE",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
    902: {
        img: require('@/assets/products8/detailimg2.png'),
        title: "Network Power Huawei Rectifier Module EPW50-48A",
        chipset: 'PM7X8IS-635161',
        frequency: '1x698-960/1x698-862/1x880-960/1x1427-2690/4x1710-2690',
        hor: '65/65/65/65/65',
        gain: '17/16/16.5/18/18',
        electrical: '2-12/2-12/2-12/2-12/2-12',
        dimension: '2700x499x199',
        radome: 'Fiberglass',
        connector: '4.3-10(F)x16',
    },
}